import { setSourceInfo } from "@elevenlabs/client/internal";
import { PACKAGE_VERSION } from "./version.js";
setSourceInfo({ name: "react_sdk", version: PACKAGE_VERSION });
export * from "@elevenlabs/client";
// Scribe exports
export { useScribe, AudioFormat, CommitStrategy, RealtimeEvents, } from "./scribe.js";
// Conversation context API
export { ConversationProvider } from "./conversation/ConversationProvider.js";
export { useConversationControls } from "./conversation/ConversationControls.js";
export { useConversationStatus } from "./conversation/ConversationStatus.js";
export { useConversationInput } from "./conversation/ConversationInput.js";
export { useConversationMode } from "./conversation/ConversationMode.js";
export { useConversationFeedback } from "./conversation/ConversationFeedback.js";
export { useRawConversation } from "./conversation/ConversationContext.js";
export { useConversation } from "./conversation/useConversation.js";
export { useConversationClientTool } from "./conversation/ConversationClientTools.js";
//# sourceMappingURL=index.js.map